import ModifierOptionsField from './ModifierOptionsField'
class ModifierOptionsFieldArray extends React.Component {
  render () {
    const {fields} = this.props
    return (<div className='row'>
      <div className='form-group col-sm-12 mb-0px'>
        <button className='btn btn-primary btn-block' onClick={this._onClickAdd}>Add Options</button>
      </div>
      {fields.map((member, index) => <ModifierOptionsField member={member} onDelete={() => this._onDelete(index)} />)}
    </div>)
  }

  _onDelete = (index) => {
    const {fields} = this.props
    fields.remove(index)
  }

  _onClickAdd = () => {
    const {fields} = this.props
    fields.push({
      name: null,
      price: null
    })
  }
}

export default ModifierOptionsFieldArray



// WEBPACK FOOTER //
// ./app/pages/Library/Modifier/Detail/ModifierForm/ModifierOptionsModal/ModifierOptionsFieldArray/ModifierOptionsFieldArray.js